import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

/**
 * New Relic browser agent, bundled rather than inlined in public/index.html.
 *
 * Import this before anything else in the entry so the agent starts as early as the bundle allows.
 * It exposes its API on `window.newrelic`, which is what Helpers/newrelic (nrWrap) reads.
 * The agent's feature chunks are loaded by webpack from our own CDN, not from js-agent.newrelic.com.
 */
const info = {
  beacon: 'bam.nr-data.net',
  errorBeacon: 'bam.nr-data.net',
  licenseKey: '6666054f03',
  applicationID: '55223369',
  sa: 1,
};

// Monitoring is best-effort: this runs during the entry module's evaluation, so a throw here would
// stop the app from hydrating. The old inline script could fail without that side effect.
try {
  // eslint-disable-next-line no-new
  new BrowserAgent({
    init: {
      distributed_tracing: { enabled: true },
      performance: { capture_measures: true },
      privacy: { cookies_enabled: true },
    },
    info,
    loader_config: {
      accountID: '702504',
      trustKey: '3680512',
      agentID: '197161665',
      licenseKey: info.licenseKey,
      applicationID: info.applicationID,
    },
  });
} catch (e) {
  console.error('New Relic agent failed to initialise', e); // eslint-disable-line no-console
}
